<script>
	import { lang } from "./scripts/stores";
	import { isFirstVisit, getLangParams } from "./scripts/utils";
	import SettingsMenu from "./components/SettingsMenu.svelte";
	import QuestionsPage from "./routes/QuestionsPage.svelte";
	import Home from "./routes/Home.svelte";
	import Router from "svelte-spa-router";
	import Info from "./routes/Info.svelte";
	import AllResults from "./routes/AllResults.svelte";
	import ResultsInfo from "./routes/ResultsInfo.svelte";
	import ResultsPage from "./routes/ResultsPage.svelte";
	import CreateUser from "./routes/CreateUser.svelte";
	import AddUserInfo from "./routes/AddUserInfo.svelte";
	import SelectLangModal from "./components/SelectLangModal.svelte";


	const routes = {
		"/": Home,
		"/form/:group?/:page?": QuestionsPage,
		"/info/:group?": Info,
		"/answers/:group": AllResults,
		"/results-info": ResultsInfo,
		"/results-page": ResultsPage,
		"/create-user": CreateUser,
		"/add-user-info": AddUserInfo
	}

	const langParams = getLangParams();

	let firstVisit = false;
	let open = false;              
	let icon = "language";

	if(langParams !== null) {
		$lang = langParams;
		localStorage.setItem("firstVisit", "" + new Date().getTime());
	}
	else {
		firstVisit = isFirstVisit();
	}
</script>

<style>
	main {
		min-height: 100%;
		padding: 10px;
		padding-top: 3rem;
		padding-bottom: 5.5rem;
		background: #fff;
	}
	.nav {
		position: fixed;
		top: 0;
		width: 100%;
		height: 3rem;
		margin: 0;
		padding: 0 .5rem;
		background: #570df8;
		color: #fff;
		z-index: 100;
	}
	.nav .material-icons, nav a {
		color: #fff;
		line-height: 3rem;
		vertical-align: middle;
	}
	.nav h2 { 
		line-height: 3rem;
		margin: 0 .5rem !important;
		display: inline-block;
		font-size: 1.35rem !important;
		vertical-align: top;
	}
	.right {
		float: right;
		margin-right: 1rem;
	}
</style>

<svelte:head>
	<title>
		{$lang == "fi" ? "Aistiesteettömyyssovellus" : "Sensory accessibility app"}
	</title>
</svelte:head>

<nav class="nav">
	<a href="/#/"><i class="material-icons">home</i></a>

	<a href="javascript:void(0)" class="right" on:click={ () => open = !open }>
		{ $lang.toUpperCase() }
		<i class="material-icons"> { icon } </i>
	</a>
</nav>

<main>
	<Router { routes } />
</main>

<SettingsMenu bind:open bind:icon />
<SelectLangModal show={ firstVisit } />

